var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 163.661,
    height: 44.958,
    viewBox: "0 0 163.661 44.958",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-483.527 -411.527)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 23.384,
    transform: "translate(489.774 451.013)",
    fill: "none",
    stroke: "#f1f3f6",
    strokeLinecap: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.906,
    y2: 34.013,
    transform: "translate(489 417)",
    fill: "none",
    stroke: "#f1f3f6",
    strokeLinecap: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.906,
    y1: 34.013,
    transform: "translate(508.906 417)",
    fill: "none",
    stroke: "#f1f3f6",
    strokeLinecap: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.107,
    y2: 34.013,
    transform: "translate(528.812 417)",
    fill: "none",
    stroke: "#f1f3f6",
    strokeLinecap: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.107,
    y1: 34.013,
    transform: "translate(542.919 417)",
    fill: "none",
    stroke: "#f1f3f6",
    strokeLinecap: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    y1: 34.013,
    x2: 14.107,
    transform: "translate(557.026 417)",
    fill: "none",
    stroke: "#f1f3f6",
    strokeLinecap: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x2: 15.655,
    transform: "translate(571.907 417)",
    fill: "none",
    stroke: "#f1f3f6",
    strokeLinecap: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x2: 15.385,
    transform: "translate(572.176 451.013)",
    fill: "none",
    stroke: "#f1f3f6",
    strokeLinecap: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1961.5,441.506s11.514-1.118,11.364,18.476",
    transform: "translate(-1373.939 -24.495)",
    fill: "none",
    stroke: "#f1f3f6",
    strokeLinecap: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1961.5,457.01s11.514.939,11.364-15.516",
    transform: "translate(-1373.939 -6.007)",
    fill: "none",
    stroke: "#f1f3f6",
    strokeLinecap: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1961.5,450s6.988.514,6.9-8.5",
    transform: "translate(-1325.209 1.01)",
    fill: "none",
    stroke: "#f1f3f6",
    strokeLinecap: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1961.5,441.5s6.988-.514,6.9,8.5",
    transform: "translate(-1325.209 -24.495)",
    fill: "none",
    stroke: "#1568e6",
    strokeLinecap: "round",
    strokeWidth: 8,
    strokeDasharray: "0 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1968.4,450s-6.988.514-6.9-8.5",
    transform: "translate(-1349.726 1.01)",
    fill: "none",
    stroke: "#1568e6",
    strokeLinecap: "round",
    strokeWidth: 8,
    strokeDasharray: "0 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1968.4,441.5s-6.988-.514-6.9,8.5",
    transform: "translate(-1349.726 -24.495)",
    fill: "none",
    stroke: "#f1f3f6",
    strokeLinecap: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1961.5,441.5s6.988-.514,6.9,8.5",
    transform: "translate(-1325.209 -7.44)",
    fill: "none",
    stroke: "#f1f3f6",
    strokeLinecap: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1968.4,450s-6.988.514-6.9-8.5",
    transform: "translate(-1349.747 -15.972)",
    fill: "none",
    stroke: "#f1f3f6",
    strokeLinecap: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x2: 18.843,
    transform: "translate(617.836 451.013)",
    fill: "none",
    stroke: "#f1f3f6",
    strokeLinecap: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x2: 18.843,
    transform: "translate(617.836 417)",
    fill: "none",
    stroke: "#f1f3f6",
    strokeLinecap: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x2: 17.628,
    transform: "translate(618.647 434.08)",
    fill: "none",
    stroke: "#f1f3f6",
    strokeLinecap: "round",
    strokeWidth: 8
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logoDark.aaa9ea04cab56d0760238a034b962b99.svg";
export { ForwardRef as ReactComponent };